import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Circle, Color, Svg } from "react-native-svg";

const Bullet: FC<{ style?: StyleProp<ViewStyle>; color?: Color }> = ({ style, color }) => (
  <Svg style={style} viewBox="0 0 7 7" fill="none">
    <Circle cx="3.5" cy="3.5" r="3.5" fill={color || "#000"} />
  </Svg>
);

export default Bullet;
